import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { XUXDrawerSidebarService } from '../services/xux-drawer-sidebar.service';
import { XUXDrawerContainerComponent } from './xux-drawer-container/xux-drawer-container.component';
import { XUXDrawerContentComponent } from './xux-drawer-content/xux-drawer-content.component';
import { XUXDrawerSidebarComponent } from './xux-drawer-sidebar/xux-drawer-sidebar.component';

export * from './xux-drawer-container/xux-drawer-container.component';
export * from './xux-drawer-sidebar/xux-drawer-sidebar.component';
export * from './xux-drawer-content/xux-drawer-content.component';

@NgModule({
  imports: [CommonModule, FormsModule, RouterModule],
  declarations: [
    XUXDrawerContainerComponent,
    XUXDrawerContentComponent,
    XUXDrawerSidebarComponent,
  ],
  exports: [
    XUXDrawerContainerComponent,
    XUXDrawerContentComponent,
    XUXDrawerSidebarComponent,
  ],
  providers: [],
})
export class XUXDrawerModule {
  public static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: XUXDrawerModule,
      providers: [XUXDrawerSidebarService],
    };
  }
}
